export default __webpack_public_path__ + "static/media/landingActive.d20f635b.svg";